"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultHasuraBackendPlusKey = void 0;
exports.DefaultHasuraBackendPlusKey = Symbol();
//# sourceMappingURL=inject-key.js.map